module.exports = "<p>\r\n  footer works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Fed/src/app/components/shared/layout/footer/footer.component.html
// module id = ../../../../../src/app/components/shared/layout/footer/footer.component.html
// module chunks = main